require("bootstrap/js/transition");
require("bootstrap/js/alert");
require("bootstrap/js/button");
require("bootstrap/js/carousel");
require("bootstrap/js/collapse");
require("bootstrap/js/dropdown");
require("bootstrap/js/modal");
require("bootstrap/js/tooltip");
require("bootstrap/js/popover");
require("bootstrap/js/scrollspy");
require("bootstrap/js/tab");
require("bootstrap/js/affix");


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-webpack/bootstrap-scripts.loader.js!./~/bootstrap-webpack/bootstrap.config.js
// module id = 1470
// module chunks = 0